import { BrowserRouter, Navigate, Route, Routes } from "react-router";

import { LocaleLayout, detectPreferredLanguage } from "./components/LocaleLayout";
import { AppLinkFallback } from "./pages/AppLinkFallback";
import { Blog } from "./pages/Blog";
import { DeleteAccount } from "./pages/DeleteAccount";
import { EsimCheckout } from "./pages/EsimCheckout";
import { EsimPackageDetails } from "./pages/EsimPackageDetails";
import { EsimShop } from "./pages/EsimShop";
import { EsimSuccess } from "./pages/EsimSuccess";
import { Home } from "./pages/Home";
import { LegalDocument } from "./pages/LegalDocument";
import { ShortShareLink } from "./pages/ShortShareLink";
import { WaitlistEnded } from "./pages/WaitlistEnded";

function RootRedirect() {
  return <Navigate to={`/${detectPreferredLanguage()}`} replace />;
}

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<RootRedirect />} />
        <Route
          path="confirm"
          element={
            <AppLinkFallback
              title="Confirm your email in AlbaVox"
              description="Open AlbaVox to finish confirming your email address."
            />
          }
        />
        <Route
          path="reset-password"
          element={
            <AppLinkFallback
              title="Reset your password in AlbaVox"
              description="Open AlbaVox to choose a new password for your account."
            />
          }
        />
        <Route
          path="trip-invitation"
          element={
            <AppLinkFallback
              title="Open your trip invitation"
              description="Open AlbaVox to accept or manage this trip invitation."
            />
          }
        />
        <Route
          path="login"
          element={
            <AppLinkFallback
              title="Sign in to AlbaVox"
              description="Open AlbaVox to sign in with the account details from your email."
            />
          }
        />
        <Route
          path="esim"
          element={
            <AppLinkFallback
              title="Open eSIM in AlbaVox"
              description="Open AlbaVox to browse eSIM plans for your trip."
            />
          }
        />
        <Route
          path="my-esim"
          element={
            <AppLinkFallback
              title="Open My eSIM in AlbaVox"
              description="Open AlbaVox to view your eSIM plans, QR code, and installation details."
            />
          }
        />
        <Route path="users/:userId" element={<AppLinkFallback />} />
        <Route path="adventures/:productCode" element={<AppLinkFallback />} />
        <Route path="beach/:beachId" element={<AppLinkFallback />} />
        <Route path="culture/:cultureId" element={<AppLinkFallback />} />
        <Route path="nature/:natureId" element={<AppLinkFallback />} />
        <Route path=":sharePrefix/:slug" element={<ShortShareLink />} />
        <Route path="post/:id" element={<AppLinkFallback />} />
        <Route path="story/:id" element={<AppLinkFallback />} />
        <Route path="meetup/:id" element={<AppLinkFallback />} />
        <Route path="trip/:id" element={<AppLinkFallback />} />
        <Route path="event/:id" element={<AppLinkFallback />} />
        <Route path="tour/:id" element={<AppLinkFallback />} />
        <Route path="offer/:id" element={<AppLinkFallback />} />
        <Route path="place/:id" element={<AppLinkFallback />} />
        <Route path="photo-spots/:id" element={<AppLinkFallback />} />
        <Route path="share/:payload" element={<AppLinkFallback />} />
        <Route path="home" element={<AppLinkFallback />} />
        <Route path=":lang" element={<LocaleLayout />}>
          <Route index element={<Home />} />
          <Route path="blog" element={<Blog />} />
          <Route path="waitlist" element={<WaitlistEnded />} />
          <Route path="esim/shop" element={<EsimShop />} />
          <Route path="esim/package" element={<EsimPackageDetails />} />
          <Route path="esim/checkout" element={<EsimCheckout />} />
          <Route path="esim/success" element={<EsimSuccess />} />
          <Route path="delete-account" element={<DeleteAccount />} />
          <Route path="privacy" element={<LegalDocument slug="privacy" />} />
          <Route path="terms" element={<LegalDocument slug="terms" />} />
          <Route path="cookies" element={<LegalDocument slug="cookies" />} />
          <Route
            path="community-guidelines"
            element={<LegalDocument slug="community-guidelines" />}
          />
          <Route path="refunds" element={<LegalDocument slug="refunds" />} />
          <Route
            path="supplier-agreement"
            element={<LegalDocument slug="supplier-agreement" />}
          />
          <Route
            path="creator-monetization"
            element={<LegalDocument slug="creator-monetization" />}
          />
          <Route path="*" element={<Home />} />
        </Route>
        <Route path="*" element={<RootRedirect />} />
      </Routes>
    </BrowserRouter>
  );
}
